function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 2H14L20 8V20C20 21.1 19.1 22 18 22H5.99C4.89 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2ZM6 20H18V9H13V4H6V20Z",
  fill: "black",
  fillOpacity: 0.54
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.8335 14C7.8335 11.7042 9.70433 9.83334 12.0002 9.83334C14.296 9.83334 16.1668 11.7042 16.1668 14C16.1668 16.2958 14.296 18.1667 12.0002 18.1667C9.70433 18.1667 7.8335 16.2958 7.8335 14ZM11.5835 11.9167H12.4168V13.5833H14.0835V14.4167H12.4168V16.0833H11.5835V14.4167H9.91683V13.5833H11.5835V11.9167Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgNoteEmpty24Px = function SvgNoteEmpty24Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoteEmpty24Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note_empty_24px.c2ca414a.svg";
export { ForwardRef as ReactComponent };